export const LANGS = ["sv", "en", "de"];

const sv = {
  meta: {
    title: "Vimmerbyferie – Karlstugan & Björkslingan, två stugor i Småland",
    description:
      "Två charmiga stugor i Vimmerby, Småland: Karlstugan Cottage och Björkslingan. Bilder, fakta, tips om utflykter i närheten och bokning via Booking.com.",
  },
  nav: {
    home: "Hem",
    cottages: "Våra stugor",
    about: "Om oss",
    activities: "Aktiviteter i närheten",
    contact: "Kontakt",
    menu: "Meny",
    closeMenu: "Stäng meny",
    language: "Språk",
    main: "Huvudmeny",
  },
  brandTag: "Stugor i Småland",
  hero: {
    pre: "Välkommen till",
    eyebrow: "Två charmiga stugor i Småland",
    intro:
      "Landa i lugnet, upptäck naturen och njut av tiden tillsammans. Här hittar du mer information om Karlstugan och Björkslingan och tips inför vistelsen.",
    cta: "Upptäck våra stugor",
    secondary: "Ställ en fråga",
    line: "Två röda stugor med naturen runt knuten.",
    alt: "Röda stugor i en blommande sommaräng i Småland",
  },
  features: [
    { title: "Två unika stugor", text: "Karlstugan och Björkslingan" },
    { title: "Nära naturen", text: "Skog, sjöar och vandring" },
    { title: "Bokning via Booking.com", text: "Direkt i respektive annons" },
    { title: "Nära Astrid Lindgrens Värld", text: "Cirka 14–15 km bort" },
  ],
  featuresTagline: "Välkommen till lugna dagar i Småland",
  cottages: {
    eyebrow: "Våra stugor",
    title: "Två stugor – var och en med sin egen charm",
    lead: "Karlstugan och Björkslingan ligger i trakterna kring Vimmerby. Jämför stugorna, titta på bilderna och välj det boende som passar din resa.",
    factsTitle: "Fakta & bekvämligheter",
    roomsTitle: "Planlösning",
    equipmentTitle: "Utrustning i stugan",
    goodToKnowTitle: "Bra att veta",
    address: "Adress",
    book: "Boka via Booking.com",
    newTab: "öppnas i ny flik",
    gallery: "Bildgalleri",
    showAll: "Visa alla {n} bilder",
    showLess: "Visa färre bilder",
    open: "Öppna bild: {c}",
    more: "+{n} bilder",
    cottageNo: "Stuga",
  },
  karlstugan: {
    tagline: "Rymligt & hemtrevligt",
    place: "Solnehult · Vimmerby",
    intro:
      "Här får du gott om plats med tre sovrum, kök, trädgård och uteplats. Ett bra boende för dig som vill varva utflykter runt Vimmerby med sköna dagar vid stugan.",
    facts: [
      "≈100 m²",
      "3 sovrum",
      "Vardagsrum",
      "Utrustat kök",
      "Badrum",
      "Terrass",
      "Trädgård",
      "Grillmöjligheter",
      "Gratis privat parkering",
      "Vandring & fiske i området",
      "≈15 km till Astrid Lindgrens Värld",
    ],
  },
  bjorkslingan: {
    tagline: "Ombonat med sjöutsikt",
    place: "Björkslingan · Vimmerby",
    intro:
      "Björkslingan har två sovrum, utrustat kök och terrass med sjöutsikt. Ett trivsamt boende för dig som vill ha nära till både natur och utflykter.",
    facts: [
      "≈72 m²",
      "2 sovrum",
      "2 badrum",
      "Vardagsrum",
      "Utrustat kök",
      "Terrass",
      "Grill",
      "Parkering",
      "Sjöutsikt",
      "≈14 km till Astrid Lindgrens Värld",
    ],
  },
  captions: {
    frontFurniture: "Framsidan med trädgårdsmöbler",
    houseGarden: "Huset och trädgården",
    gardenSide: "Trädgårdssidan",
    living: "Vardagsrum",
    livingCorner: "Hörna i vardagsrummet",
    dining: "Matsal",
    kitchen: "Kök",
    kitchenNook: "Kök med matplats",
    bedroom: "Sovrum",
    bathroom: "Badrum",
    veranda: "Veranda",
    verandaView: "Utsikt från verandan",
    roses: "Rosor vid huset",
    inGarden: "I trädgården",
    surroundings: "Omgivningar",
    front: "Framsidan",
    underBirches: "Huset under björkarna",
    houseFurniture: "Huset med trädgårdsmöbler",
    bigBirch: "Under den stora björken",
    garden: "Trädgården",
    pergola: "Pergola och terrass",
    terrace: "Terrass",
    diningArea: "Matplats",
    gardenSeating: "Sittplats i trädgården",
    woodsSeating: "Sittplats bland träden",
  },
  lightbox: {
    label: "Bildvisning",
    close: "Stäng",
    prev: "Föregående bild",
    next: "Nästa bild",
  },
  missing: "Bild saknas",
  about: {
    eyebrow: "Om oss",
    title: "Två charmiga stugor nära Vimmerby",
    p1: "I trakterna kring Vimmerby hittar du Karlstugan och Björkslingan. Båda har sin egen karaktär och ligger nära skog, sjöar och utflyktsmål.",
    p2: "Lär känna stugorna genom bilderna, jämför vad som ingår och hitta inspiration till dagarna i Småland. När du har valt stuga bokar du via Booking.com.",
    p3: "Undrar du något om boendena? Du hittar kontaktmöjligheterna längre ner på sidan.",
    quote: "Landa i lugnet",
  },
  activities: {
    eyebrow: "Upplev närområdet",
    title: "Tips och upplevelser i Vimmerby",
    lead: "Från Astrid Lindgrens Värld till skogspromenader och fiske – här finns tips för dagarna runt Vimmerby.",
    natureTitle: "Naturen runt stugorna",
    nature: [
      { title: "Skog & stigar", text: "Promenader och vandring i den småländska naturen." },
      { title: "Sjöar & bad", text: "Bad och naturupplevelser vid traktens sjöar." },
      { title: "Fiske", text: "Fiskevatten och fiskekort – se kommunens fiskeguide." },
    ],
    destinationsTitle: "Utvalda besöksmål",
    cards: {
      alv: {
        name: "Astrid Lindgrens Värld",
        text: "Temaparken där Astrid Lindgrens berättelser blir levande – för stora och små.",
        note: "Obs! Ny infart – följ parkens egen vägbeskrivning, GPS kan visa fel.",
        link: "Hitta hit",
      },
      nas: {
        name: "Astrid Lindgrens Näs",
        text: "Astrid Lindgrens barndomsmiljö i Vimmerby, med utställningar och trädgårdar.",
        link: "Hitta hit",
      },
      filmbyn: {
        name: "Filmbyn Småland",
        text: "I Mariannelund – om filmerna som spelades in efter Astrid Lindgrens böcker.",
        link: "Läs mer",
      },
      fishing: {
        name: "Fiske i Vimmerby kommun",
        text: "Fiskevatten, tips och var du köper fiskekort i kommunen.",
        link: "Läs mer",
      },
      tourist: {
        name: "Vimmerby turistbyrå",
        text: "Fler utflyktsmål, upplevelser och tips från turistbyrån.",
        link: "Se alla tips",
      },
    },
  },
  contact: {
    eyebrow: "Kontakt",
    title: "Har du en fråga?",
    lead: "Undrar du något om stugorna? Skriv gärna vad du vill veta. Bokning sker via Booking.com.",
    noBooking: "Ingen bokning genomförs automatiskt.",
    directTitle: "Vill du boka direkt?",
    directText: "Bokning sker via Booking.com:",
    demoNote: "Demoversion: formuläret kan inte skicka förfrågningar förrän e-postleveransen har aktiverats.",
    name: "Namn",
    namePh: "För- och efternamn",
    email: "E-post",
    emailPh: "namn@exempel.se",
    cottage: "Stuga",
    options: { karlstugan: "Karlstugan", bjorkslingan: "Björkslingan", both: "Båda", unsure: "Vet ej ännu" },
    dates: "Ungefärlig period",
    dateFrom: "Från",
    dateTo: "Till",
    optional: "valfritt",
    message: "Meddelande",
    messagePh: "Skriv din fråga här …",
    submit: "Skicka förfrågan",
    sending: "Skickar …",
    sendFailed: "Det gick inte att skicka förfrågan. Försök senare eller boka direkt via Booking.com.",
    errors: {
      nameRequired: "Ange ditt namn.",
      emailRequired: "Ange din e-postadress.",
      emailInvalid: "Ange en giltig e-postadress, t.ex. namn@exempel.se.",
      messageRequired: "Skriv ett meddelande.",
    },
    successScript: "Tack",
    success: "Tack! Din förfrågan har skickats. En förfrågan är inte en bekräftad bokning.",
    again: "Skicka en ny förfrågan",
  },
  cottagePage: {
    viewCottage: "Se stugan",
    backHome: "Till startsidan",
    eyebrow: "Upptäck stugan",
    verifiedTitle: "Fakta & bekvämligheter",
    galleryTitle: "Se mer av stugan",
    galleryLead: "Bläddra bland de riktiga bilderna från boendet.",
    nearbyEyebrow: "Runt omkring",
    nearbyTitle: "Att upptäcka runt Vimmerby",
    nearbyLead: "Här hittar du några utvalda och verifierade länkar för utflykter och upplevelser i Vimmerbytrakten.",
    bookingTitle: "Vill du boka stugan?",
    bookingText: "Själva bokningen görs via Booking.com. Har du en fråga kan du använda kontaktformuläret på startsidan.",
    bookingButton: "Boka via Booking.com",
    questionButton: "Ställ en fråga",
    openCover: "Öppna huvudbild",
  },
  footer: {
    tagline: "Två charmiga stugor i Småland",
    cottagesTitle: "Stugorna",
    onBooking: "på Booking.com",
    pageTitle: "På sidan",
    note: "Vimmerbyferie är ett preliminärt arbetsnamn · Demoversion",
    top: "Till toppen",
  },
};

const en = {
  meta: {
    title: "Vimmerbyferie – Karlstugan & Björkslingan, two cottages in Småland",
    description:
      "Two charming holiday cottages in Vimmerby, Småland: Karlstugan Cottage and Björkslingan. Photos, facts, ideas for nearby day trips and booking via Booking.com.",
  },
  nav: {
    home: "Home",
    cottages: "Our cottages",
    about: "About us",
    activities: "Things to do",
    contact: "Contact",
    menu: "Menu",
    closeMenu: "Close menu",
    language: "Language",
    main: "Main menu",
  },
  brandTag: "Cottages in Småland",
  hero: {
    pre: "Welcome to",
    eyebrow: "Two charming cottages in Småland",
    intro:
      "Slow down, enjoy the countryside and discover the area around Vimmerby. Find information about Karlstugan and Björkslingan, plus ideas for your stay.",
    cta: "Explore our cottages",
    secondary: "Ask a question",
    line: "Enjoy the peace, the nature and the Småland countryside.",
    alt: "Red cottages in a flowering summer meadow in Småland",
  },
  features: [
    { title: "Two unique cottages", text: "Karlstugan and Björkslingan" },
    { title: "Close to nature", text: "Forests, lakes and hiking" },
    { title: "Book via Booking.com", text: "Directly in each listing" },
    { title: "Near Astrid Lindgren's World", text: "About 14–15 km away" },
  ],
  featuresTagline: "Welcome to a relaxing stay in Småland!",
  cottages: {
    eyebrow: "Our cottages",
    title: "Two cottages, each with its own character",
    lead: "Karlstugan and Björkslingan are both located in the countryside around Vimmerby. Read about the cottages, browse the photos and book the one that suits your trip via Booking.com.",
    factsTitle: "Facts & amenities",
    roomsTitle: "Layout & rooms",
    equipmentTitle: "Facilities in the cottage",
    goodToKnowTitle: "Good to know",
    address: "Address",
    book: "Book via Booking.com",
    newTab: "opens in a new tab",
    gallery: "Photo gallery",
    showAll: "Show all {n} photos",
    showLess: "Show fewer photos",
    open: "Open photo: {c}",
    more: "+{n} photos",
    cottageNo: "Cottage",
  },
  karlstugan: {
    tagline: "Spacious & welcoming",
    place: "Solnehult · Vimmerby",
    intro:
      "A spacious cottage with three bedrooms, a welcoming kitchen, a garden and a terrace. A lovely base for enjoying nature and exploring Vimmerby.",
    facts: [
      "≈100 m²",
      "3 bedrooms",
      "Living room",
      "Equipped kitchen",
      "Bathroom",
      "Terrace",
      "Garden",
      "Barbecue facilities",
      "Free private parking",
      "Hiking & fishing in the area",
      "≈15 km to Astrid Lindgren's World",
    ],
  },
  bjorkslingan: {
    tagline: "Cosy, with lake views",
    place: "Björkslingan · Vimmerby",
    intro:
      "A comfortable cottage with two bedrooms, a fully equipped kitchen, a terrace and lake views. An inviting place for a peaceful stay in Småland.",
    facts: [
      "≈72 m²",
      "2 bedrooms",
      "2 bathrooms",
      "Living room",
      "Equipped kitchen",
      "Terrace",
      "Barbecue",
      "Parking",
      "Lake view",
      "≈14 km to Astrid Lindgren's World",
    ],
  },
  captions: {
    frontFurniture: "Front with garden furniture",
    houseGarden: "House and garden",
    gardenSide: "Garden side",
    living: "Living room",
    livingCorner: "Living room corner",
    dining: "Dining room",
    kitchen: "Kitchen",
    kitchenNook: "Kitchen with dining nook",
    bedroom: "Bedroom",
    bathroom: "Bathroom",
    veranda: "Veranda",
    verandaView: "View from the veranda",
    roses: "Roses by the house",
    inGarden: "In the garden",
    surroundings: "Surroundings",
    front: "Front of the house",
    underBirches: "The house beneath the birches",
    houseFurniture: "House with garden furniture",
    bigBirch: "Beneath the big birch",
    garden: "Garden",
    pergola: "Pergola and terrace",
    terrace: "Terrace",
    diningArea: "Dining area",
    gardenSeating: "Garden seating",
    woodsSeating: "Seating among the trees",
  },
  lightbox: {
    label: "Photo viewer",
    close: "Close",
    prev: "Previous photo",
    next: "Next photo",
  },
  missing: "Image unavailable",
  about: {
    eyebrow: "About us",
    title: "Two cottages waiting for you in Småland",
    p1: "Karlstugan and Björkslingan are both located in the countryside around Vimmerby – surrounded by greenery, with forests and lakes nearby and Astrid Lindgren's World just a short drive away.",
    p2: "This page gathers what a booking listing can't quite hold: more photos, a feel for the place and tips for your stay. You book as usual via Booking.com.",
    p3: "Have a question? Feel free to get in touch using the form below.",
    quote: "Slow down",
  },
  activities: {
    eyebrow: "Explore the area",
    title: "Things to see and do in Vimmerby",
    lead: "Discover Astrid Lindgren's world, Småland's nature and more places to visit in the area.",
    natureTitle: "Nature around the cottages",
    nature: [
      { title: "Forests & trails", text: "Walks and hikes in Småland's countryside." },
      { title: "Lakes & swimming", text: "Swimming and nature experiences at the local lakes." },
      { title: "Fishing", text: "Fishing waters and licences – see the municipality's fishing guide." },
    ],
    destinationsTitle: "Selected places to visit",
    cards: {
      alv: {
        name: "Astrid Lindgren's World",
        text: "The theme park where Astrid Lindgren's stories come to life – for young and old.",
        note: "Note: new entrance – follow the park's own directions, as GPS may be wrong.",
        link: "Getting there",
      },
      nas: {
        name: "Astrid Lindgrens Näs",
        text: "Astrid Lindgren's childhood surroundings in Vimmerby, with exhibitions and gardens.",
        link: "Getting there",
      },
      filmbyn: {
        name: "Filmbyn Småland",
        text: "In Mariannelund – all about the films made from Astrid Lindgren's books.",
        link: "Read more",
      },
      fishing: {
        name: "Fishing in Vimmerby Municipality",
        text: "Fishing waters, tips and where to buy a fishing licence locally.",
        link: "Read more",
      },
      tourist: {
        name: "Vimmerby Tourist Office",
        text: "More places to visit, experiences and tips from the tourist office.",
        link: "See all tips",
      },
    },
  },
  contact: {
    eyebrow: "Contact",
    title: "Have a question?",
    lead: "Have a question about either cottage? Send an enquiry.",
    noBooking: "This does not create a confirmed reservation.",
    directTitle: "Want to book directly?",
    directText: "Bookings are made via Booking.com:",
    demoNote: "Demo version: the form does not send anything and no data is stored.",
    name: "Name",
    namePh: "First and last name",
    email: "Email",
    emailPh: "name@example.com",
    cottage: "Cottage",
    options: { karlstugan: "Karlstugan", bjorkslingan: "Björkslingan", both: "Both", unsure: "Not sure yet" },
    dates: "Approximate dates",
    dateFrom: "From",
    dateTo: "To",
    optional: "optional",
    message: "Message",
    messagePh: "Write your question here …",
    submit: "Send enquiry",
    sending: "Sending…",
    sendFailed: "Your enquiry could not be sent. Please try again later or book directly via Booking.com.",
    errors: {
      nameRequired: "Please enter your name.",
      emailRequired: "Please enter your email address.",
      emailInvalid: "Please enter a valid email address, e.g. name@example.com.",
      messageRequired: "Please write a message.",
    },
    successScript: "Thank you",
    success: "Thank you! This is a demo – no enquiry has been sent and no booking has been made.",
    again: "Send another enquiry",
  },
  cottagePage: {
    viewCottage: "View cottage",
    backHome: "Back to home",
    eyebrow: "Discover the cottage",
    verifiedTitle: "Facts & amenities",
    galleryTitle: "See more of the cottage",
    galleryLead: "Browse the real photos from the property.",
    nearbyEyebrow: "Around the area",
    nearbyTitle: "Things to discover around Vimmerby",
    nearbyLead: "A selection of verified links for day trips and experiences around Vimmerby.",
    bookingTitle: "Would you like to book?",
    bookingText: "Bookings are made through Booking.com. If you have a question, use the enquiry form on the home page.",
    bookingButton: "Book via Booking.com",
    questionButton: "Ask a question",
    openCover: "Open main photo",
  },
  footer: {
    tagline: "Two charming cottages in Småland",
    cottagesTitle: "The cottages",
    onBooking: "on Booking.com",
    pageTitle: "On this page",
    note: "Vimmerbyferie is a preliminary working name · Demo version",
    top: "Back to top",
  },
};

const de = {
  meta: {
    title: "Vimmerbyferie – Karlstugan & Björkslingan, zwei Ferienhäuser in Småland",
    description:
      "Zwei charmante Ferienhäuser in Vimmerby, Småland: Karlstugan Cottage und Björkslingan. Fotos, Fakten, Ausflugstipps in der Nähe und Buchung über Booking.com.",
  },
  nav: {
    home: "Startseite",
    cottages: "Unsere Ferienhäuser",
    about: "Über uns",
    activities: "Ausflugsziele",
    contact: "Kontakt",
    menu: "Menü",
    closeMenu: "Menü schließen",
    language: "Sprache",
    main: "Hauptmenü",
  },
  brandTag: "Ferienhäuser in Småland",
  hero: {
    pre: "Willkommen bei",
    eyebrow: "Zwei charmante Ferienhäuser in Småland",
    intro:
      "Genießen Sie Ruhe, Natur und die Umgebung von Vimmerby. Hier finden Sie Informationen zu Karlstugan und Björkslingan sowie Tipps für Ihren Aufenthalt.",
    cta: "Unsere Ferienhäuser entdecken",
    secondary: "Eine Frage stellen",
    line: "Genießen Sie die Ruhe, die Natur und die Landschaft Smålands.",
    alt: "Rote Häuser auf einer blühenden Sommerwiese in Småland",
  },
  features: [
    { title: "Zwei einzigartige Ferienhäuser", text: "Karlstugan und Björkslingan" },
    { title: "Mitten in der Natur", text: "Wälder, Seen und Wandern" },
    { title: "Buchung über Booking.com", text: "Direkt im jeweiligen Inserat" },
    { title: "Nah an Astrid Lindgrens Welt", text: "Rund 14–15 km entfernt" },
  ],
  featuresTagline: "Willkommen zu einem erholsamen Aufenthalt in Småland!",
  cottages: {
    eyebrow: "Unsere Ferienhäuser",
    title: "Zwei Häuser, jedes mit eigenem Charakter",
    lead: "Karlstugan und Björkslingan liegen beide in der ländlichen Umgebung von Vimmerby. Lesen Sie mehr über die Häuser, stöbern Sie in den Fotos und buchen Sie das passende Haus über Booking.com.",
    factsTitle: "Fakten & Ausstattung",
    roomsTitle: "Raumaufteilung",
    equipmentTitle: "Ausstattung im Ferienhaus",
    goodToKnowTitle: "Gut zu wissen",
    address: "Adresse",
    book: "Über Booking.com buchen",
    newTab: "öffnet in einem neuen Tab",
    gallery: "Bildergalerie",
    showAll: "Alle {n} Fotos anzeigen",
    showLess: "Weniger Fotos anzeigen",
    open: "Foto öffnen: {c}",
    more: "+{n} Fotos",
    cottageNo: "Ferienhaus",
  },
  karlstugan: {
    tagline: "Geräumig & gemütlich",
    place: "Solnehult · Vimmerby",
    intro:
      "Ein geräumiges Ferienhaus mit drei Schlafzimmern, gemütlicher Küche, Garten und Terrasse. Ein schöner Ausgangspunkt für Natur und Ausflüge rund um Vimmerby.",
    facts: [
      "≈100 m²",
      "3 Schlafzimmer",
      "Wohnzimmer",
      "Ausgestattete Küche",
      "Badezimmer",
      "Terrasse",
      "Garten",
      "Grillmöglichkeit",
      "Kostenloser Privatparkplatz",
      "Wandern & Angeln in der Umgebung",
      "≈15 km bis Astrid Lindgrens Welt",
    ],
  },
  bjorkslingan: {
    tagline: "Gemütlich, mit Seeblick",
    place: "Björkslingan · Vimmerby",
    intro:
      "Ein gemütliches Ferienhaus mit zwei Schlafzimmern, gut ausgestatteter Küche, Terrasse und Seeblick. Ideal für erholsame Tage in Småland.",
    facts: [
      "≈72 m²",
      "2 Schlafzimmer",
      "2 Badezimmer",
      "Wohnzimmer",
      "Ausgestattete Küche",
      "Terrasse",
      "Grill",
      "Parkplatz",
      "Seeblick",
      "≈14 km bis Astrid Lindgrens Welt",
    ],
  },
  captions: {
    frontFurniture: "Vorderseite mit Gartenmöbeln",
    houseGarden: "Haus und Garten",
    gardenSide: "Gartenseite",
    living: "Wohnzimmer",
    livingCorner: "Ecke im Wohnzimmer",
    dining: "Esszimmer",
    kitchen: "Küche",
    kitchenNook: "Küche mit Essplatz",
    bedroom: "Schlafzimmer",
    bathroom: "Badezimmer",
    veranda: "Veranda",
    verandaView: "Blick von der Veranda",
    roses: "Rosen am Haus",
    inGarden: "Im Garten",
    surroundings: "Umgebung",
    front: "Vorderseite des Hauses",
    underBirches: "Das Haus unter den Birken",
    houseFurniture: "Haus mit Gartenmöbeln",
    bigBirch: "Unter der großen Birke",
    garden: "Garten",
    pergola: "Pergola und Terrasse",
    terrace: "Terrasse",
    diningArea: "Essbereich",
    gardenSeating: "Sitzplatz im Garten",
    woodsSeating: "Sitzplatz zwischen den Bäumen",
  },
  lightbox: {
    label: "Bildansicht",
    close: "Schließen",
    prev: "Vorheriges Foto",
    next: "Nächstes Foto",
  },
  missing: "Bild nicht verfügbar",
  about: {
    eyebrow: "Über uns",
    title: "Zwei Ferienhäuser, die in Småland auf Sie warten",
    p1: "Karlstugan und Björkslingan liegen beide in der Gegend um Vimmerby – umgeben von viel Grün, mit Wäldern und Seen in der Nähe und Astrid Lindgrens Welt nur eine kurze Autofahrt entfernt.",
    p2: "Auf dieser Seite finden Sie, was in einem Buchungsinserat kaum Platz hat: mehr Fotos, einen Eindruck von der Umgebung und Tipps für Ihren Aufenthalt. Gebucht wird wie gewohnt über Booking.com.",
    p3: "Haben Sie eine Frage? Schreiben Sie uns gern über das Formular weiter unten.",
    quote: "Zur Ruhe kommen",
  },
  activities: {
    eyebrow: "Die Umgebung entdecken",
    title: "Tipps und Erlebnisse in Vimmerby",
    lead: "Entdecken Sie Astrid Lindgrens Welt, Smålands Natur und weitere Ausflugsziele der Region.",
    natureTitle: "Natur rund um die Ferienhäuser",
    nature: [
      { title: "Wald & Wege", text: "Spaziergänge und Wanderungen in der Natur Smålands." },
      { title: "Seen & Baden", text: "Baden und Naturerlebnisse an den Seen der Umgebung." },
      { title: "Angeln", text: "Angelgewässer und Angelkarten – siehe Angelführer der Gemeinde." },
    ],
    destinationsTitle: "Ausgewählte Ausflugsziele",
    cards: {
      alv: {
        name: "Astrid Lindgrens Welt",
        text: "Der Themenpark, in dem Astrid Lindgrens Geschichten lebendig werden – für Groß und Klein.",
        note: "Hinweis: Neue Zufahrt – bitte folgen Sie der Wegbeschreibung des Parks, das Navi kann falsch führen.",
        link: "Anfahrt",
      },
      nas: {
        name: "Astrid Lindgrens Näs",
        text: "Astrid Lindgrens Kindheitsumgebung in Vimmerby, mit Ausstellungen und Gärten.",
        link: "Anfahrt",
      },
      filmbyn: {
        name: "Filmbyn Småland",
        text: "In Mariannelund – rund um die Filme nach Astrid Lindgrens Büchern.",
        link: "Mehr erfahren",
      },
      fishing: {
        name: "Angeln in der Gemeinde Vimmerby",
        text: "Angelgewässer, Tipps und Verkaufsstellen für Angelkarten vor Ort.",
        link: "Mehr erfahren",
      },
      tourist: {
        name: "Touristinformation Vimmerby",
        text: "Weitere Ausflugsziele, Erlebnisse und Tipps der Touristinformation.",
        link: "Alle Tipps ansehen",
      },
    },
  },
  contact: {
    eyebrow: "Kontakt",
    title: "Haben Sie eine Frage?",
    lead: "Haben Sie eine Frage zu einem der Ferienhäuser? Senden Sie uns eine unverbindliche Anfrage.",
    noBooking: "Es erfolgt keine automatische Buchung.",
    directTitle: "Direkt buchen?",
    directText: "Gebucht wird über Booking.com:",
    demoNote: "Demoversion: Das Formular versendet nichts und speichert keine Daten.",
    name: "Name",
    namePh: "Vor- und Nachname",
    email: "E-Mail",
    emailPh: "name@beispiel.de",
    cottage: "Ferienhaus",
    options: { karlstugan: "Karlstugan", bjorkslingan: "Björkslingan", both: "Beide", unsure: "Noch unklar" },
    dates: "Ungefährer Zeitraum",
    dateFrom: "Von",
    dateTo: "Bis",
    optional: "optional",
    message: "Nachricht",
    messagePh: "Ihre Frage …",
    submit: "Anfrage senden",
    sending: "Wird gesendet …",
    sendFailed: "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es später erneut oder buchen Sie direkt über Booking.com.",
    errors: {
      nameRequired: "Bitte geben Sie Ihren Namen ein.",
      emailRequired: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
      emailInvalid: "Bitte geben Sie eine gültige E-Mail-Adresse ein, z. B. name@beispiel.de.",
      messageRequired: "Bitte schreiben Sie eine Nachricht.",
    },
    successScript: "Danke",
    success: "Vielen Dank! Dies ist eine Demo – es wurde keine Anfrage gesendet und keine Buchung angelegt.",
    again: "Neue Anfrage senden",
  },
  cottagePage: {
    viewCottage: "Ferienhaus ansehen",
    backHome: "Zur Startseite",
    eyebrow: "Ferienhaus entdecken",
    verifiedTitle: "Fakten & Ausstattung",
    galleryTitle: "Mehr vom Ferienhaus",
    galleryLead: "Entdecken Sie die echten Fotos der Unterkunft.",
    nearbyEyebrow: "In der Umgebung",
    nearbyTitle: "Rund um Vimmerby entdecken",
    nearbyLead: "Eine Auswahl geprüfter Links zu Ausflügen und Erlebnissen rund um Vimmerby.",
    bookingTitle: "Möchten Sie buchen?",
    bookingText: "Die Buchung erfolgt über Booking.com. Bei Fragen nutzen Sie bitte das Anfrageformular auf der Startseite.",
    bookingButton: "Über Booking.com buchen",
    questionButton: "Eine Frage stellen",
    openCover: "Hauptbild öffnen",
  },
  footer: {
    tagline: "Zwei charmante Ferienhäuser in Småland",
    cottagesTitle: "Die Ferienhäuser",
    onBooking: "auf Booking.com",
    pageTitle: "Auf dieser Seite",
    note: "Vimmerbyferie ist ein vorläufiger Arbeitstitel · Demoversion",
    top: "Nach oben",
  },
};

export const translations = { sv, en, de };

export const fmt = (str, vars) =>
  Object.entries(vars).reduce((s, [k, v]) => s.replace(`{${k}}`, v), str);
